module.exports = __webpack_public_path__ + "img/1.a14dbe11.png";